import gql from 'graphql-tag';

const GET_AUDIENCE_SCHEMA = gql`
  query internalMicroserviceAudienceSchema {
    internalMicroserviceAudienceSchema
  }
`;

export default GET_AUDIENCE_SCHEMA;
